var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10006_131847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7468 6.85535C15.1243 6.3799 14.3926 6.0681 13.6186 5.94846H13.6219V3.81385C14.1986 3.54448 14.5683 2.96665 14.5711 2.33011V2.28022C14.5687 1.37302 13.8338 0.638146 12.9266 0.635721H12.8767C11.9695 0.638146 11.2346 1.37302 11.2322 2.28022V2.33011C11.235 2.96665 11.6047 3.54448 12.1814 3.81385V5.95293C11.3691 6.07713 10.604 6.41379 9.96365 6.92876L4.09308 2.35672C4.36002 1.35737 3.76623 0.330846 2.76688 0.0639041C1.76753 -0.203037 0.741002 0.390717 0.47406 1.39007C0.207119 2.38942 0.800873 3.41595 1.80026 3.68289C2.2781 3.81051 2.78699 3.74399 3.21593 3.49776L8.98778 7.99104C7.92381 9.59624 7.95239 11.6895 9.05985 13.265L7.30334 15.0215C7.16233 14.9766 7.01551 14.9526 6.86754 14.9505C6.02544 14.9505 5.34281 15.6331 5.34281 16.4752C5.34281 17.3173 6.02544 18 6.86754 18C7.70964 18 8.39227 17.3173 8.39227 16.4752C8.39019 16.3273 8.36629 16.1804 8.32129 16.0394L10.059 14.3018C12.1152 15.8724 15.0554 15.4788 16.6261 13.4225C18.1967 11.3662 17.8031 8.42599 15.7468 6.85535ZM12.9044 12.9822L12.8989 12.9811C11.5711 12.978 10.4972 11.8992 10.5003 10.5714C10.5034 9.24369 11.5822 8.16985 12.91 8.17287C14.236 8.17593 15.3092 9.25206 15.3086 10.5781C15.3085 11.9059 14.2322 12.9822 12.9044 12.9822Z",
    fill: "#FF7B57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10006_131847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.1726c6364d2521d76477169a7d77ecab.svg";
export { ForwardRef as ReactComponent };